import React, { useState, useEffect } from "react";
import "./carouselSlider.css";

const CarouselSlider = ({ items = [], renderItem, visibleSlides = 3 }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(visibleSlides);

  // Responsive breakpoints
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setSlidesToShow(1);
      else if (window.innerWidth < 1024) setSlidesToShow(2);
      else setSlidesToShow(visibleSlides);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [visibleSlides]);

  if (!items.length) return null;

  const goPrev = () => {
    setActiveIndex((prev) =>
      prev === 0 ? items.length - slidesToShow : prev - 1
    );
  };

  const goNext = () => {
    setActiveIndex((prev) =>
      prev >= items.length - slidesToShow ? 0 : prev + 1
    );
  };

  return (
    <div className="cb-carousel">
      {/* Prev Button */}
      <button
        className="cb-carousel__nav cb-carousel__nav--prev"
        onClick={goPrev}
      >
        ‹
      </button>

      {/* Viewport */}
      <div className="cb-carousel__viewport">
        <div
          className="cb-carousel__track"
          style={{
            transform: `translateX(-${(activeIndex * 100) / slidesToShow}%)`,
          }}
        >
          {items.map((item, i) => (
            <div className="cb-carousel__slide" key={i}>
              {renderItem(item, i)}
            </div>
          ))}
        </div>
      </div>

      {/* Next Button */}
      <button
        className="cb-carousel__nav cb-carousel__nav--next"
        onClick={goNext}
      >
        ›
      </button>
    </div>
  );
};

export default CarouselSlider;



